import { useEffect, useState } from "react";
import { CircleNotch, MagnifyingGlass, ShieldStar } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Avatar } from "@/components/Avatar";
import { Input } from "@/components/ui/input";

export default function Pokerians() {
  const [users, setUsers] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/pokerians").then((r) => setUsers(r.data));
  }, []);

  if (users === null) return <div className="flex justify-center py-20"><CircleNotch size={32} className="animate-spin text-primary" /></div>;

  const filtered = users.filter((u) => {
    const s = `${u.nickname || ""} ${u.name || ""}`.toLowerCase();
    return s.includes(q.toLowerCase());
  });

  return (
    <div className="animate-fade-up">
      <h1 className="font-heading font-black text-4xl sm:text-5xl uppercase tracking-tighter">Pokerians</h1>
      <p className="text-muted-foreground mt-1 mb-5">Every member — nickname and who's really behind it.</p>

      <div className="relative mb-4">
        <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search nickname or name…" className="bg-card border-border h-11 pl-10" data-testid="pokerians-search" />
      </div>

      <div className="grid gap-2 sm:grid-cols-2">
        {filtered.map((u) => (
          <div key={u.id} className="border border-border bg-card rounded-sm p-3 flex items-center gap-3" data-testid={`pokerian-${u.id}`}>
            <Avatar name={u.nickname || u.name} path={u.avatar_path} size={44} enlargeable />
            <div className="min-w-0">
              <div className="font-heading font-bold text-lg uppercase tracking-tight leading-none flex items-center gap-1.5">
                {u.nickname || u.name}
                {(u.role === "admin" || u.role === "primary_admin") && <ShieldStar size={15} weight="fill" className="text-primary" title="Admin" />}
              </div>
              {u.nickname && <div className="text-sm text-muted-foreground mt-0.5 truncate">{u.name}</div>}
            </div>
          </div>
        ))}
        {filtered.length === 0 && <p className="text-muted-foreground">No one found.</p>}
      </div>
    </div>
  );
}
